/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MeetingSectionTopicLink', 'model/MeetingReport', 'model/MeetingTemplateReport', 'model/Meeting', 'model/FileTransferHelperEntity'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/MeetingSectionTopicLink'), require('../model/MeetingReport'), require('../model/MeetingTemplateReport'), require('../model/Meeting'), require('../model/FileTransferHelperEntity'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MeetingSectionTopicLink, root.ForStractionServiceApi.MeetingReport, root.ForStractionServiceApi.MeetingTemplateReport, root.ForStractionServiceApi.Meeting, root.ForStractionServiceApi.FileTransferHelperEntity);
  }
}(this, function(ApiClient, MeetingSectionTopicLink, MeetingReport, MeetingTemplateReport, Meeting, FileTransferHelperEntity) {
  'use strict';

  /**
   * Meeting service.
   * @module api/MeetingApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new MeetingApi. 
   * @alias module:api/MeetingApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the meetingAddContentToMeetingPut operation.
     * @callback module:api/MeetingApi~meetingAddContentToMeetingPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MeetingReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addContentToMeeting
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/MeetingSectionTopicLink>} body 
     * @param {Integer} meetingID 
     * @param {Integer} sectionID 
     * @param {module:api/MeetingApi~meetingAddContentToMeetingPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MeetingReport}
     */
    this.meetingAddContentToMeetingPut = function(_4SAPIAppID, body, meetingID, sectionID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingAddContentToMeetingPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingAddContentToMeetingPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingAddContentToMeetingPut";
      }

      // verify the required parameter 'sectionID' is set
      if (sectionID == undefined || sectionID == null) {
        throw "Missing the required parameter 'sectionID' when calling meetingAddContentToMeetingPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID,
        'sectionID': sectionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MeetingReport;

      return this.apiClient.callApi(
        '/Meeting/addContentToMeeting', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingCloneGet operation.
     * @callback module:api/MeetingApi~meetingCloneGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clone
     * @param {String} _4SAPIAppID 
     * @param {Integer} meetingID 
     * @param {String} name 
     * @param {Date} startDate 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.repeatCount  (default to 0)
     * @param {Integer} opts.generationInterval  (default to 0)
     * @param {module:api/MeetingApi~meetingCloneGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingCloneGet = function(_4SAPIAppID, meetingID, name, startDate, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingCloneGet";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingCloneGet";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling meetingCloneGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling meetingCloneGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID,
        'name': name,
        'startDate': startDate,
        'repeatCount': opts['repeatCount'],
        'generationInterval': opts['generationInterval']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/clone', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingCreateFromTemplatePut operation.
     * @callback module:api/MeetingApi~meetingCreateFromTemplatePutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {module:model/MeetingTemplateReport} body 
     * @param {Date} startDate 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceTemplateID  (default to 0)
     * @param {Integer} opts.repeatCount  (default to 0)
     * @param {Integer} opts.generationInterval  (default to 0)
     * @param {module:api/MeetingApi~meetingCreateFromTemplatePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.meetingCreateFromTemplatePut = function(_4SAPIAppID, body, startDate, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingCreateFromTemplatePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingCreateFromTemplatePut";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling meetingCreateFromTemplatePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': startDate,
        'sourceTemplateID': opts['sourceTemplateID'],
        'repeatCount': opts['repeatCount'],
        'generationInterval': opts['generationInterval']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/Meeting/createFromTemplate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingDeleteGet operation.
     * @callback module:api/MeetingApi~meetingDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/MeetingApi~meetingDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling meetingDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingDeleteMeetingMinutesFileGet operation.
     * @callback module:api/MeetingApi~meetingDeleteMeetingMinutesFileGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteMeetingMinutesFile
     * @param {String} _4SAPIAppID 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingDeleteMeetingMinutesFileGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingDeleteMeetingMinutesFileGet = function(_4SAPIAppID, meetingID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingDeleteMeetingMinutesFileGet";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingDeleteMeetingMinutesFileGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/deleteMeetingMinutesFile', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingDownloadMeetingPDFGet operation.
     * @callback module:api/MeetingApi~meetingDownloadMeetingPDFGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * downloadMeetingPDF
     * @param {String} _4SAPIAppID 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingDownloadMeetingPDFGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.meetingDownloadMeetingPDFGet = function(_4SAPIAppID, meetingID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingDownloadMeetingPDFGet";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingDownloadMeetingPDFGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Meeting/downloadMeetingPDF', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingEditAllPut operation.
     * @callback module:api/MeetingApi~meetingEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Meeting>} body 
     * @param {module:api/MeetingApi~meetingEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingEditPut operation.
     * @callback module:api/MeetingApi~meetingEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/Meeting} body 
     * @param {module:api/MeetingApi~meetingEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingEditStatusGet operation.
     * @callback module:api/MeetingApi~meetingEditStatusGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} meetingID 
     * @param {Integer} statusID 
     * @param {Boolean} sendPDFToParticipants 
     * @param {Object} opts Optional parameters
     * @param {String} opts.coverMessage  (default to )
     * @param {String} opts.recipientFilter  (default to )
     * @param {module:api/MeetingApi~meetingEditStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingEditStatusGet = function(_4SAPIAppID, meetingID, statusID, sendPDFToParticipants, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingEditStatusGet";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingEditStatusGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling meetingEditStatusGet";
      }

      // verify the required parameter 'sendPDFToParticipants' is set
      if (sendPDFToParticipants == undefined || sendPDFToParticipants == null) {
        throw "Missing the required parameter 'sendPDFToParticipants' when calling meetingEditStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID,
        'statusID': statusID,
        'sendPDFToParticipants': sendPDFToParticipants,
        'coverMessage': opts['coverMessage'],
        'recipientFilter': opts['recipientFilter']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/editStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingGenerateMeetingMinutesGet operation.
     * @callback module:api/MeetingApi~meetingGenerateMeetingMinutesGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateMeetingMinutes
     * @param {String} _4SAPIAppID 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingGenerateMeetingMinutesGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingGenerateMeetingMinutesGet = function(_4SAPIAppID, meetingID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingGenerateMeetingMinutesGet";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingGenerateMeetingMinutesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/generateMeetingMinutes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingGenerateMeetingPdfPut operation.
     * @callback module:api/MeetingApi~meetingGenerateMeetingPdfPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateMeetingPdf
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingGenerateMeetingPdfPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.meetingGenerateMeetingPdfPut = function(_4SAPIAppID, body, meetingID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingGenerateMeetingPdfPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingGenerateMeetingPdfPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingGenerateMeetingPdfPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Meeting/generateMeetingPdf', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingGenerateMeetingWordDocPut operation.
     * @callback module:api/MeetingApi~meetingGenerateMeetingWordDocPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateMeetingWordDoc
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingGenerateMeetingWordDocPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.meetingGenerateMeetingWordDocPut = function(_4SAPIAppID, body, meetingID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingGenerateMeetingWordDocPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingGenerateMeetingWordDocPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingGenerateMeetingWordDocPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Meeting/generateMeetingWordDoc', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingInviteMeetingMinutesEditorGet operation.
     * @callback module:api/MeetingApi~meetingInviteMeetingMinutesEditorGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * inviteMeetingMinutesEditor
     * @param {String} _4SAPIAppID 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingInviteMeetingMinutesEditorGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingInviteMeetingMinutesEditorGet = function(_4SAPIAppID, meetingID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingInviteMeetingMinutesEditorGet";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingInviteMeetingMinutesEditorGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/inviteMeetingMinutesEditor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingLoadAllGet operation.
     * @callback module:api/MeetingApi~meetingLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MeetingReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxSectionsCount  (default to 0)
     * @param {module:api/MeetingApi~meetingLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MeetingReport>}
     */
    this.meetingLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxSectionsCount': opts['maxSectionsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [MeetingReport];

      return this.apiClient.callApi(
        '/Meeting/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingLoadGet operation.
     * @callback module:api/MeetingApi~meetingLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MeetingReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxSectionsCount  (default to 0)
     * @param {module:api/MeetingApi~meetingLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MeetingReport}
     */
    this.meetingLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling meetingLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'maxSectionsCount': opts['maxSectionsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MeetingReport;

      return this.apiClient.callApi(
        '/Meeting/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingLoadManyPut operation.
     * @callback module:api/MeetingApi~meetingLoadManyPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MeetingReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMany
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxSectionsCount  (default to 0)
     * @param {module:api/MeetingApi~meetingLoadManyPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MeetingReport>}
     */
    this.meetingLoadManyPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingLoadManyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingLoadManyPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxSectionsCount': opts['maxSectionsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [MeetingReport];

      return this.apiClient.callApi(
        '/Meeting/loadMany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingRecreateMeetingFromTemplateGet operation.
     * @callback module:api/MeetingApi~meetingRecreateMeetingFromTemplateGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MeetingReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * recreateMeetingFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/MeetingApi~meetingRecreateMeetingFromTemplateGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MeetingReport}
     */
    this.meetingRecreateMeetingFromTemplateGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingRecreateMeetingFromTemplateGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling meetingRecreateMeetingFromTemplateGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MeetingReport;

      return this.apiClient.callApi(
        '/Meeting/recreateMeetingFromTemplate', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingSendArchivedPDFPut operation.
     * @callback module:api/MeetingApi~meetingSendArchivedPDFPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendArchivedPDF
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} meetingID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.coverMessage  (default to )
     * @param {module:api/MeetingApi~meetingSendArchivedPDFPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingSendArchivedPDFPut = function(_4SAPIAppID, body, meetingID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingSendArchivedPDFPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingSendArchivedPDFPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingSendArchivedPDFPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID,
        'coverMessage': opts['coverMessage']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/sendArchivedPDF', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingSendInvitationsPut operation.
     * @callback module:api/MeetingApi~meetingSendInvitationsPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendInvitations
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} meetingID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.coverMessage  (default to )
     * @param {Boolean} opts.includeCalendarEvent  (default to false)
     * @param {module:api/MeetingApi~meetingSendInvitationsPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingSendInvitationsPut = function(_4SAPIAppID, body, meetingID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingSendInvitationsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingSendInvitationsPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingSendInvitationsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID,
        'coverMessage': opts['coverMessage'],
        'includeCalendarEvent': opts['includeCalendarEvent']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/sendInvitations', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingSignMeetingMinutesPut operation.
     * @callback module:api/MeetingApi~meetingSignMeetingMinutesPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * signMeetingMinutes
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingSignMeetingMinutesPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.meetingSignMeetingMinutesPut = function(_4SAPIAppID, body, meetingID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingSignMeetingMinutesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingSignMeetingMinutesPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingSignMeetingMinutesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Meeting/signMeetingMinutes', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the meetingUploadMeetingMinutesPut operation.
     * @callback module:api/MeetingApi~meetingUploadMeetingMinutesPutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * uploadMeetingMinutes
     * @param {String} _4SAPIAppID 
     * @param {module:model/FileTransferHelperEntity} body 
     * @param {Integer} meetingID 
     * @param {module:api/MeetingApi~meetingUploadMeetingMinutesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.meetingUploadMeetingMinutesPut = function(_4SAPIAppID, body, meetingID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling meetingUploadMeetingMinutesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling meetingUploadMeetingMinutesPut";
      }

      // verify the required parameter 'meetingID' is set
      if (meetingID == undefined || meetingID == null) {
        throw "Missing the required parameter 'meetingID' when calling meetingUploadMeetingMinutesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'meetingID': meetingID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Meeting/uploadMeetingMinutes', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
